import { createFileRoute } from '@tanstack/react-router';
import { ExternalUploadPage } from '../features/external-upload/ExternalUploadPage';

function UploadPage() {
  const { id } = Route.useParams();
  return <ExternalUploadPage id={id} />;
}

export const Route = createFileRoute('/upload_/$id')({ component: UploadPage });
